// Kullanıcı yetki kataloğu (Kullanıcı Düzenle > Yetkiler). addon: Platform Owner'da kapalıysa gizlenir ve geçersiz olur
const CRUD = ['view', 'create', 'edit', 'delete'];

export const ACTION_LABELS = { view: 'Görüntüleme', create: 'Ekleme', edit: 'Düzenleme', delete: 'Silme', reset_password: 'Şifre Sıfırlama' };

export const PERMISSION_GROUPS = [
  { title: 'Ana Menüler', modules: [
    { key: 'dashboard', label: 'Dashboard', actions: ['view'] },
    { key: 'locations', label: 'Lokasyonlar', actions: CRUD },
    { key: 'companies', label: 'Firmalar ve Raporlar', actions: CRUD },
    { key: 'employees', label: 'Personel', actions: CRUD },
    { key: 'equipment', label: 'İş Ekipmanı', actions: CRUD },
    { key: 'equipment_types', label: 'Ekipman Türleri (tanımlar)', actions: CRUD },
    { key: 'work_permits', label: 'Çalışma İzinleri', actions: CRUD },
    { key: 'work_areas', label: 'Çalışma Alanları ve İş Tipi / Çeşidi', actions: CRUD },
    { key: 'templates', label: 'Eksiklik Şablonları', actions: CRUD },
  ] },
  { title: 'İSG ve Saha', modules: [
    { key: 'isg_commitments', label: 'İSG Taahhütnameleri', actions: CRUD, tabs: [['list', 'Taahhütnameler'], ['acc', 'Onaylayanlar'], ['pending', 'Onaylamayanlar']] },
    { key: 'doc_library', label: 'Dokümantasyon', actions: CRUD },
    { key: 'stores', label: 'Mağazalar', actions: CRUD },
    { key: 'special_situations', label: 'Özel Durumlar', actions: CRUD, tabs: [['list', 'Tanımlar'], ['calendar', 'Takvim']] },
    { key: 'time_rules', label: 'Talep Zaman Kuralları', actions: CRUD, tabs: [['creation', 'A) Talep Oluşturma'], ['work', 'B) Çalışma Zamanı'], ['calendar', 'Takvim']] },
  ] },
  { title: 'Five Star', addon: 'five_star', modules: [
    { key: 'five_star', label: 'Five Star Denetimi', actions: CRUD, addon: 'five_star', tabs: [['mine', 'Bana Atananlar'], ['all', 'Tümü']] },
    { key: 'firm_evaluation', label: 'Firma Değerlendirme', actions: CRUD, addon: 'five_star', tabs: [['firma', 'Firmalar'], ['personel', 'Personel'], ['gecmis', 'Rozet Geçmişi'], ['uzman', 'Uzman Performansı'], ['ayarlar', 'Ayarlar']] },
    { key: 'five_star_criteria', label: 'Five Star Başlıkları', actions: CRUD, addon: 'five_star' },
  ] },
  { title: 'Yapay Zekâ', modules: [
    { key: 'ai_chatbot', label: 'AI Chatbot', actions: ['view'], addon: 'ai_chatbot' },
    { key: 'ai_doc_reading', label: 'AI Belge Okuma', actions: ['view'], addon: 'ai_doc_reading' },
  ] },
  { title: 'Duyurular ve Bildirimler', modules: [
    { key: 'login_announcements', label: 'Giriş Sayfası Duyuruları', actions: CRUD },
    { key: 'user_announcements', label: 'Kullanıcı Duyuruları', actions: CRUD },
    { key: 'settings', label: 'E-posta Ayarları', actions: ['view', 'edit'] },
  ] },
  { title: 'Yönetim', modules: [
    { key: 'users', label: 'Kullanıcı Yönetimi', actions: [...CRUD, 'reset_password'] },
    { key: 'company_statuses', label: 'Firma Statüsü', actions: CRUD },
    { key: 'system_settings', label: 'Sistem Ayarları', actions: ['view', 'edit'], tabs: [['genel', 'Genel'], ['bildirimler', 'Bildirimler'], ['kvkk', 'KVKK'], ['guvenlik', 'Güvenlik'], ['eposta-gecmisi', 'E-posta Geçmişi']] },
    { key: 'user_guide', label: 'Kullanım Kılavuzu', actions: ['view', 'edit'] },
  ] },
];

export const MODULE_ADDON = Object.fromEntries(PERMISSION_GROUPS.flatMap(g => g.modules).filter(m => m.addon).map(m => [m.key, m.addon]));
